import React,{useEffect, useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import {CircleLoader} from 'react-spinners';
import _ from 'lodash'


const pageSize = 5;

const TcAddUserRolemain = () => {

    const[role, setRole] =useState([])
    const[getrole, setGetRole] =useState([])
    const[deleteRole, setDeleteRole] =useState([])
    const[pop,setpop] = useState(false);
    const[roleAction,setRoleAction] = useState();

    const [allusers,setAllusers]= useState([])
    const [paginatedPosts, setpaginatedPosts] = useState();
 
  
useEffect(()=>{

  GetTcUserRole()
  
},[])


function GetTcUserRole(){

      fetch('https://localhost:44312/Api/Tc/GetTcUserRole', {
        method:'GET',
        headers : {
  
          "Content-type": "application/json",
  
          "Accept": "application/json",
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
  
  
      })
       .then(response => response.json())
      .then(data => {
        console.log(data)   
        //setRole(data);
        localStorage.setItem("UserRole", JSON.stringify(data));
        setAllusers(data)
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
     
      });
    }
  
   
     function handlechange(){
      let input = document.getElementById('roleInput').value;
      console.log(input)
      if(!input){
        document.getElementById("userroleerror").innerHTML = "Role Required";
      }
     else{
      document.getElementById("userroleerror").innerHTML =""
     }
     }


    function Tcaddrole(e){

     e.preventDefault()

    let input = document.getElementById('roleInput').value;
    console.log(input)

    if(!input){
      document.getElementById("userroleerror").innerHTML = "Role Required";
    }
   else{
    document.getElementById("userroleerror").innerHTML =""
   
   let alldata = localStorage.getItem("UserRole");
 

   let roledata =  JSON.parse(alldata);
 console.log(roledata)


   let names = roledata.map((item) => item.role);
   console.log(names)


   let result = names.includes(input);  
console.log(result)  


if(result==true){
  document.getElementById('roleerror-notify').style.display = "block"
  setTimeout(()=>{
    document.getElementById('roleerror-notify').style.display = "none"
  },1000)
}
 if(result==false){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      var roleInput = document.getElementById('roleInput').value;
    
     const body ={
             
          role: roleInput,
          roleValue: "01",
          createdBy:"123"        
    
     }
     console.log(body);
        
      axios({          
         method: "POST", 
         url: `${BASE_URL}/Tc/AddTcUserRole`,      
         //url: "https://localhost:44312/Api/Tc/AddTcUserRole",
         data:body,
         headers: {             
           'Content-Type': 'application/json', 
           "Authorization": bearer,

         }
       
       })
       .then((response) =>{
         
        console.log(response.data);
        if(response.data.status=='Success'){
          document.getElementById('success-notify').style.display = "block"
           setTimeout(()=>{
             document.getElementById('success-notify').style.display = "none"
           },1000)
        }
       
        document.getElementById('roleInput').value="";
        
        GetTcUserRole()
         }) 
      
         .catch(error => {
          console.log(error);
    
         document.getElementById('error-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('error-notify').style.display = "none"
         },1000)
  
         })
}
 }
   
    }


    function delRole(Id){
     
      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
     
      const body ={
        id:Id
      }
       console.log(body)
        axios({
       
        method:"POST",
         //url: `${BASE_URL}/Tc/Sectiondelete`,
       url:"https://localhost:44312/Api/Tc/DeleteTcUserRole",
       data:body,
       headers: {
       "Content-Type" : "application/json",
       'Authorization':bearer
       }
    
        })
        .then((response) =>{
        console.log(response.data);
     
        if(response.data.status=='Success'){
          document.getElementById('del-notify').style.display = "block"
           setTimeout(()=>{
             document.getElementById('del-notify').style.display = "none"
           },1000)
        }
         document.getElementById("modalDeleteForm").style.display = "none";
         GetTcUserRole()       
        })
    }

  
  function uncheckAll() {
    var inputs = document.querySelectorAll('.checkboxInput');
    for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
    }
}

    function updateRoleAction(Id){
     
      let arr = [];
      let checkboxes = document.querySelectorAll("input[type='checkbox']:checked");
     
     checkboxes.forEach((item)=>{
        arr.push(item.value)
     }) 
  console.log(arr)
   

      var checkboxInput = arr.toString();
        
      if(!checkboxInput){
        document.getElementById('actionErr').innerHTML=""
      }
      else{
      const body ={
      
        value: checkboxInput,      
        id:Id     
      
       }
       console.log(body);
      
       let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        axios({          
           method: "POST", 
           url: `${BASE_URL}/Tc/UpdateTcRoleAction`,      
           //url: "https://localhost:44312/Api/Tc/UpdateTcRoleAction",
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             'Authorization':bearer     
           }
         
         })
         .then((response) =>{
          console.log(response.data);
          if(response.data.status=='Success'){
            document.getElementById('assign-notify').style.display = "block"
             setTimeout(()=>{
               document.getElementById('assign-notify').style.display = "none"
             },1000)
          }
       
          uncheckAll()
          GetTcUserRole() 
           })
          } 
          }


          function getdelDetails(Id){
   
            let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
            
           
           const body ={
            
            id:Id
          
           }
           console.log(body);
          
          
            axios({          
               method: "POST", 
               //url: `${BASE_URL}/Tc/EditSection`,      
               url: "https://localhost:44312/Api/Tc/SelectTcUserRole",
               data:body,
               headers: {             
                 'Content-Type': 'application/json' , 
                 'Authorization':bearer     
               }
             
             })
             .then((response) =>{
              console.log(response.data);
              setDeleteRole(response.data)
              localStorage.setItem("delrole",JSON.stringify(response.data));
              let Tcrole =  localStorage.getItem("delrole");
              let roledata =  JSON.parse(Tcrole);
              let role = roledata.map((e)=>e.role);
              setRole(role);
               }) 
          
          } 
      
    function closedelForm()
{
   document.getElementById("modalDeleteForm").style.display = "none";
 
 }


function Cancel() {
document.getElementById("modalDeleteForm").style.display = "none";      

   }

   function ConfirmDelete(Id){

    document.getElementById("modalDeleteForm").style.display = "block";
    getdelDetails(Id)
  
  }
  

  /*-----Pagination----*/

  const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  
  let data = localStorage.getItem("UserRole")
  let transdata =  JSON.parse(data);
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 5;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 1;
    
      const totalBlocks = totalNumbers + 2;
  
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination">
        <ul className="pagination">
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="page-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="page-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 2)}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`Tc-page-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

    return(
        <div className='TC-addmain'>
        
             <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcadduser'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span>UserRole</span>
    </div>
    </div>
    <div className='Tc-privacyMain' id='Tc-sectionMain'>
     
      
         <div>
         <input type="text"  id='roleInput' placeholder='Role' onKeyUp={handlechange} maxLength={20}></input>  &nbsp;&nbsp;&nbsp;&nbsp;  
  
   <button type='submit' className="UserRoleBtn" onClick={Tcaddrole}>Create</button> <br></br>
   <span id="userroleerror"></span>  
         </div> 
  
     </div>


   {/* ---  Role table  --- */}
{
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center',marginTop:'10%'}}>No Data Found</span>):(
  <div className='TCRoletable'>
<div class="TC-RoleTable">

  <table className='TC-tblhead'>
    <thead>
      <tr>          

        <th>Role</th>
        <th> Action  </th> 
        <th> Assigned Action</th>
        <th> Delete</th>
      
     </tr>
    </thead>
    <tbody>
    {currentData.map((e,index)=>{
      return<tr  key={index}>
     
        <td id='role'>{e.role}</td>     
        <td> 
       
       <label><input type="checkbox" className='checkboxInput'  id='Tc-checkbox' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Add" />Add 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'   id='Tc-checkbox' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      
       <label><input type="checkbox"  className='checkboxInput'  id='Tc-checkbox' onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Edit"/>Edit 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'  id='Tc-checkbox'  onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Delete"/>Delete 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;  
       <button onClick={()=>updateRoleAction(e.id)} id="checkboxbtn">Set</button>
      
       </td>
     {e.roleAction?  <td >{e.roleAction}</td> :<td>No Action Assign</td>  }
       {/* <td style={{inlineSize:"50px",overflowWrap:"break-word",wordWrap:"break-word"}}><i className="fa-solid fa-trash" id='Tcdelicon' onClick={()=>ConfirmDelete(e.id)} ></i></td> */}
       <td style={{inlineSize:"50px",overflowWrap:"break-word",wordWrap:"break-word"}}><i class="fa fa-refresh" aria-hidden="true" id='Tcediticon' onClick={()=>ConfirmDelete(e.id)} ></i></td>
</tr>
})}
 </tbody>
</table>

<br></br>

 
{transdata.length<=5 ? null:<nav id='Tc-Pag'>
    <ul className='Tc-pagination'>

    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={2}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 
    </ul>
  </nav>}

</div>
</div>
)}
<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Role&nbsp; <span style={{color:"blue"}}>Added</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Role&nbsp; Added </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down" style={{fontSize:'25px'}}></i></h6>
   </section>
    </div>
  </div>
</div>
<div className='TCpopfade' id='roleerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Role </p>
      <h6 class="notif-title"> Already Exists</h6>
   </section>
    </div>
  </div>
</div>
<div className='TCpopfade' id='assign-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Action&nbsp;<span style={{color:"blue"}}>Assigned</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section>   
    </div>
  </div>
</div>

<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Role&nbsp; <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
            
          </section> 
            
          
    </div>
  </div>
</div>

  
   {/* --- Delete Form--- */}

<div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{deleteRole.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
          <h5>Assigned Action to</h5> 
          <h5 style={{color:'blue'}}>{role}</h5> 
   
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>delRole(e.id)} type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>

       </div>
       
    )
}
export default  TcAddUserRolemain